import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";

import Button from "../../Button/Button";
import Container from "../../Container/Container";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";

import "../../../Style/home/cta.css";

function CTA() {
  const handleGetStarted = (e) => {
    e.preventDefault();
    if (window.location.pathname === "/contact") return;
    window.history.pushState({}, "", "/contact");
    window.dispatchEvent(new Event("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="cta" className="section section--dark section--grid cta">
      <span className="blob blob--blue cta__blob cta__blob--one" />
      <span className="blob blob--magenta cta__blob cta__blob--two" />
      <span className="blob blob--violet cta__blob cta__blob--three" />

      <Container>
        <motion.div
          className="cta__content"
          variants={staggerContainer(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <motion.h2 className="cta__title" variants={fadeUp()}>
            Ready to build a better <span className="text-gradient">growth engine?</span>
          </motion.h2>
          <motion.p className="cta__description" variants={fadeUp(0.08)}>
            Let's turn your data into opportunities and your goals into measurable results.
          </motion.p>
          <motion.div className="btn-row cta__actions" variants={fadeUp(0.16)}>
            <Button
              icon={<ArrowRight size={18} />}
              onClick={handleGetStarted}
            >
              Get Started
            </Button>
            <Button
              href="tel:+17867762152"
              variant="outline"
              onDark
              icon={<Phone size={18} />}
            >
              Talk to an Expert
            </Button>
          </motion.div>
        </motion.div>
      </Container>
    </section>
  );
}

export default CTA;